import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ExamSummary, LabworkRequestModel } from '../models';
import { Api, Session } from '../services/index';
import * as moment from 'moment';

@Component({
  selector: 'app-exam-history',
  styleUrls: ['dashboard-exam-history.css'],
  templateUrl: './dashboard-exam-history.html'
})
 
export class DashboardExamHistoryComponent implements OnInit {
	examHistories: ExamSummary[] = [];
  loading = false;
  public isRequesting: boolean;
  labworkRequestsAll: Array<LabworkRequestModel>;
  isLabworkAvailable: boolean = false;
  

  constructor(private api: Api, 
              private route: ActivatedRoute,
              private router: Router,
              public session: Session) { 
             
                


  }

	gotoDashboard() {
		this.router.navigate(['/dashboard']);
	}
  
  ngOnInit() {
   this.loading = true;
		this.isRequesting = true;

    this.loadMsgs();

    this.api.getExamSummary(this.session.patientId).subscribe(result => {
      this.examHistories = result;
      this.loading = false;
      this.isRequesting = false;

    }, ex => {
      this.loading = false; 
      this.isRequesting = false;
    });
    
  
       


  }
  
  loadPastExamDetail(intakeId) {
    this.router.navigate(['/exam-history-patient/' + intakeId])
  }

  goToMyDocuments(){
		this.router.navigate(['/mydocuments']);
  }
  loadMsgs(){

 
  
    this.api.getLabworkRequestsByUserId(this.session.patientId, 'all').subscribe(labresults => {
      this.labworkRequestsAll = labresults;
      
      if(this.labworkRequestsAll.length > 0){
        this.isLabworkAvailable = true;

      }
     });
  
   
  }

  
}
